import { Box, Image, ListItemSelect, Text } from "@wix/design-system";
import React, { useContext } from "react";
import { RicosContext, ZIndexContext } from "./../../ricos-context";
import { getScaleImageSrc } from "./../../wix-rich-content-common/lib/imageUtils";
import { convertDuration } from "../convertDuration";
import {
  INSERT_VERTICAL_EMBED_MODAL_ITEM,
  INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE
} from "../dataHooks";
const ItemsList = ({
  items,
  onClick,
  selectedItem,
  contentType,
  modalRef
}) => {
  const { t, environment } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  if (items.length === 0) {
    return /* @__PURE__ */ React.createElement(Box, { direction: "vertical", margin: "SP4", gap: "SP2", textAlign: "center" }, /* @__PURE__ */ React.createElement(Text, { size: "medium", weight: "bold", secondary: true }, t(`Embed_Vertical_${contentType}_EmptyState_NoItems_Title`)), /* @__PURE__ */ React.createElement(Text, { size: "small", secondary: true }, t(`Embed_Vertical_${contentType}_EmptyState_NoItems_Description`)));
  }
  if (!modalRef) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, items.map((item) => {
    return /* @__PURE__ */ React.createElement(
      ListItemSelect,
      {
        size: "small",
        key: item.id,
        dataHook: INSERT_VERTICAL_EMBED_MODAL_ITEM,
        title: item.name,
        selected: selectedItem?.id === item.id,
        onClick: () => onClick(item),
        ellipsis: true,
        prefix: /* @__PURE__ */ React.createElement(Box, { width: "50px", height: "50px", margin: "6px 6px 6px 0" }, /* @__PURE__ */ React.createElement(
          Image,
          {
            src: item.imageSrc ? getScaleImageSrc(item.imageSrc, 50, 50) : void 0,
            dataHook: INSERT_VERTICAL_EMBED_MODAL_ITEM_IMAGE,
            ...environment === "liveSite" ? { borderRadius: "0" } : {}
          }
        )),
        subtitle: contentType === "Bookings" ? convertDuration(item.durations, t) || void 0 : contentType === "Events" ? `${item.scheduling} | ${item.location}` : void 0,
        tooltipProps: {
          appendTo: modalRef,
          zIndex: zIndexService.getZIndex("TOOLTIP"),
          children: [],
          enterDelay: 1e3,
          placement: "top"
        }
      }
    );
  }));
};
export {
  ItemsList
};
//# sourceMappingURL=ItemsList.js.map
